<template>
  <b-notification :closable="false" has-icon type="is-danger is-light">
    <span v-html="$t('compCarbonResultsEFUpdateWarning.message-1')" />
    {{ year }}
    <span v-html="$t('compCarbonResultsEFUpdateWarning.message-2')" />
  </b-notification>
</template>

<script>
export default {
  name: 'EFUpdateWarning',
  props: {
    year: {
      type: Number,
      required: true
    }
  }
}
</script>

<style>
.notification.is-danger.is-light {
  background-color: #feecf0 !important;
  color: #cc0f35 !important;
}
</style>
